import i18next from "i18next"

// NOTE: Download the official badges here: https://developer.apple.com/app-store/marketing/guidelines/

export default async function getAppStoreBadge(): Promise<string> {
  const language = i18next.language.split("-")[0]

  try {
    const module = (await import(
      `../assets/app_store_badges/app_store_badge_${language}.svg`
    )) as { default: string }

    return module.default
  } catch {
    const module =
      await import("../assets/app_store_badges/app_store_badge_en.svg")

    return module.default
  }
}
